module.exports = __webpack_public_path__ + "static/media/money.e9a4ce8a.svg";